import { render, staticRenderFns } from "./detection-corpus-update.vue?vue&type=template&id=e3b59622&"
import script from "./detection-corpus-update.vue?vue&type=script&lang=js&"
export * from "./detection-corpus-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports